// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionReason-cls1___29cf4fcac250cb35bed","cls2":"SuggestionReason-cls2___d9a30e1054ba789a535 SuggestionReason-cls1___29cf4fcac250cb35bed"};